<template>
  <consult-contact-panel
    title="自拟组方"
    subtitle="结合中医辨证理念，为患者个性化制定用药方案"
    :show-vertical-label="true"
    date-placeholder="请选择开始服药日期"
    day-placeholder="请输入服药天数（不大于30天）"
    :show-use-days="true"
    submit-button-text="开始咨询"
    :address-required="false"
    dialog-width="600px"
    :initial-contact="initialContact"
    :initial-use-date="initialUseDate"
    :initial-use-days="initialUseDays"
    :initial-gan-zhi-prescription-time-type="initialGanZhiPrescriptionTimeType"
    :initial-gan-zhi-prescription-hour-range="initialGanZhiPrescriptionHourRange"
    @back="goBack"
    @submit="onSubmit"
  />
</template>

<script>
import ConsultContactPanel from "../widgets/ConsultContactPanel.vue";

export default {
  components: { ConsultContactPanel },
  data() {
    return {
      mode: 1,
      serviceIndex: "",
      initialContact: null,
      initialUseDate: "",
      initialUseDays: "",
      initialGanZhiPrescriptionTimeType: "",
      initialGanZhiPrescriptionHourRange: ""
    };
  },
  created() {
    if (this.$route.query.mode) this.mode = this.$route.query.mode;
    this.serviceIndex = this.$route.query.serviceIndex;

    const contact = sessionStorage.getItem("contactList");
    const consultInfo = sessionStorage.getItem("consultInfo");
    if (!this.utils.isEmptyStr(contact)) {
      this.initialContact = JSON.parse(contact);
      sessionStorage.removeItem("contactList");
      sessionStorage.removeItem("submitData");
      sessionStorage.removeItem("consultInfo");
      sessionStorage.removeItem("visitRecordId");
    } else if (!this.utils.isEmptyStr(consultInfo)) {
      const consultObj = JSON.parse(consultInfo);
      this.initialContact = consultObj.contact;
      this.initialUseDate = consultObj.useDate;
      this.initialUseDays = consultObj.useDays;
      this.initialGanZhiPrescriptionTimeType = consultObj.ganZhiPrescriptionTimeType || "";
      this.initialGanZhiPrescriptionHourRange = consultObj.ganZhiPrescriptionHourRange || "";
    }
  },
  methods: {
    goBack() {
      if (!this.utils.isEmptyStr(this.fromPath) && this.fromPath != "/") this.$router.go(-1);
      else this.$router.replace("/");
    },
    onSubmit(payload) {
      sessionStorage.removeItem("visitRecordId");
      const consultInfo = {
        contact: payload.selectContact,
        useDate: payload.useDate,
        useDays: payload.useDays,
        ganZhiPrescriptionTimeType: payload.ganZhiPrescriptionTimeType,
        ganZhiPrescriptionHourRange: payload.ganZhiPrescriptionHourRange
      };
      sessionStorage.setItem("consultInfo", JSON.stringify(consultInfo));
      sessionStorage.removeItem("submitData");
      if (this.mode == 2) {
        this.$router.push({ path: "/commonPrescriptionInfo", query: { mode: this.mode } });
      } else if (this.serviceIndex == -1) {
        this.$router.push({ path: "/GeneralPrescriptionInfo" });
      } else {
        this.$router.push({ path: "/prescriptionInfo" });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => { vm.fromPath = from.path; });
  }
};
</script>
